<template>
  <v-card class="pb-2" outlined>
    <v-layout class="my-3" row>
      <v-flex></v-flex>
      <v-col cols="5" pt-6>
        <v-text-field v-model="trailer" label="Trailer #" outlined clearable dense hide-details />
      </v-col>
      <v-flex class="pt-4">
        <v-btn
          class="mx-1"
          color="green white--text"
          @click="startLoad"
          :disabled="trailer == '' || dock === null"
        >
          Start Load
        </v-btn>
        <v-btn class="mx-1" color="red white--text" @click="stopLoad" :disabled="loadernum == ''">
          Stop Load
        </v-btn>
      </v-flex>
      <v-flex class="pt-4"> </v-flex>
    </v-layout>

    <v-flex class="text-center ma-2">
      <template v-for="d in docks">
        <v-btn
          @click="selectDock(d.number)"
          :key="d.number"
          class="btn-dock ma-2"
          :color="getDockColor(d)"
          :style="{
            'font-size': '1.1rem',
            border: d.number == selectedDockNumber ? '2px solid dodgerblue !important' : ''
          }"
        >
          {{ d.number }}
        </v-btn>
      </template>
      <br />
    </v-flex>

    <v-row align-content="center" justify="center" class="text-center pa-5" v-if="progress">
      <v-col cols="6">
        <v-progress-linear color="primary" indeterminate rounded height="5" />
        <div class="mt-4 font-weight-bold">Loading....</div>
      </v-col>
    </v-row>

    <v-card class="mt-5" flat v-if="dock && dock.loads && !progress">
      <v-card-title
        class="text-h6"
        dense
        style="background: #9e9e9e9c; display: block; height: 55px"
      >
        Loads
      </v-card-title>
      <v-card-text class="pt-2" style="border: 2px solid #9e9e9e9c">
        <v-expansion-panels
          :accordion="accordion"
          :popout="popout"
          :inset="inset"
          :multiple="multiple"
          :focusable="focusable"
          :disabled="disabled"
          :readonly="readonly"
          v-model="panel"
          v-if="dock.loads.length"
        >
          <load-item v-for="load in dock.loads" :key="load.spsoid" :load="load" />
        </v-expansion-panels>
        <span class="font-weight-bold" v-else>No Loads Available!</span>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import axios from 'axios';
import { wait } from '@/utils';

import LoadItem from '@/components/loads/LoadItem';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'Docks',
  components: { LoadItem },
  computed: {
    ...mapState('dock', ['docks', 'dock', 'selectedDockNumber'])
  },
  data() {
    return {
      progress: false,
      accordion: false,
      popout: true,
      inset: false,
      multiple: false,
      focusable: true,
      disabled: false,
      readonly: false,
      panel: [],
      snack: false,
      snackColor: '',
      snackText: '',
      selectedItem: null,
      loadStatus: true,
      current_sprunnuma: '',
      trailer: '',
      loadernum: ''
    };
  },
  methods: {
    ...mapActions('dock', ['fetchDocks', 'fetchDock']),
    ...mapActions('shippingOfflineLocation', ['fetchShippingOfflineLocations']),
    ...mapMutations('dock', ['setSelectedDockNumber']),
    getDockColor({ status }) {
      switch (status) {
        case 'Loaded':
          return 'green';
        case 'UnLoaded':
          return 'red';
        case 'PartiallyLoaded':
          return 'orange';
        case 'Empty':
          return 'gray';
        default:
          return 'white';
      }
    },
    async startLoad() {
      const res = await axios.post('/startload', {
        docknum: this.dock.number,
        trailer_num: this.trailer
      });

      if (res) {
        await this.fetchDock(this.dock.number);
        const { loads } = this.dock;
        if (!loads.length) return;
        this.loadernum = loads[0].loader_num;
      }
    },
    async stopLoad() {
      const { loads } = this.dock;
      if (!loads.length) return;
      this.loadernum = loads[0].loader_num;
      if (this.loadernum != '') {
        await axios.post('/stopload', {
          loader_num: this.loadernum
        });
      }
    },
    async selectDock(n) {
      this.progress = true;
      this.setSelectedDockNumber(n);
      await this.fetchDock(n);
      const { loads } = this.dock;
      if (!loads.length) {
        this.progress = false;
        return;
      }
      this.loadernum = loads[0].loader_num;
      this.progress = false;
      this.scrollBottom(10);
    },
    async scrollBottom() {
      await wait(100);
      const el = document.getElementById('mainContainer');
      if (el) el.scrollTop = el.scrollHeight;
    }
  },
  async mounted() {
    this.progress = true;
    this.fetchShippingOfflineLocations();
    await this.fetchDocks();
    this.progress = false;
  }
};
</script>

<style>
.btn-dock {
  min-width: 54px;
  min-height: 60px;
  max-width: 54px;
  margin-bottom: 5px;
  border-radius: 6px;
  padding: 2px;
}

.dockSelected {
  border: 2px solid dodgerblue;
}

.loadItemName {
  color: rgb(0, 68, 255);
  font-weight: bold;
  line-height: 1.3em;
}

.loadItemValue {
  color: dimgrey;
}

.loadItemCompleted {
  background: #26c6da;
}

.palletItemName {
  color: rgb(218, 164, 5);
  font-weight: bold;
}

.palletItemValue {
  color: dimgrey;
}

p.loadItemNamex {
  color: red;
  line-height: 12px;
  margin-bottom: 500px;
}

.selectedRow {
  background-color: red;
  font-weight: bold;
}
</style>